import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminEditarOrdenCompraPage } from "@/features/admin-ordenes-compra/components/AdminEditarOrdenCompraPage";
import { ordenCompraAdminQueryOptions } from "@/features/admin-ordenes-compra/hooks/use-ordenes-compra";

export const Route = createFileRoute("/_authed-tw/admin/ordenes-compra/$id")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    queryClient.ensureQueryData(ordenCompraAdminQueryOptions(id)),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminComprasSap]}>
      <AdminEditarOrdenCompraPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
